import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Logo } from "@/components/common/Logo";
import api, { humanError } from "@/lib/api";

export default function InviteAccept() {
  const [params] = useSearchParams();
  const [token, setToken] = useState(params.get("token") || "");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  useEffect(() => { setToken(params.get("token") || ""); }, [params]);

  async function onSubmit(e) {
    e.preventDefault();
    if (password.length < 8) return toast.error("Password must be at least 8 characters");
    setBusy(true);
    try {
      const { data } = await api.post("/auth/invites/accept", { token, password });
      localStorage.setItem("hs_token", data.token);
      toast.success("Invite accepted");
      nav("/app", { replace: true });
      setTimeout(() => window.location.reload(), 100);
    } catch (err) {
      toast.error(humanError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="hs-mint-gradient flex min-h-screen items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="mb-6 flex justify-center"><Logo /></div>
        <div className="rounded-2xl border border-[#E4E9EF] bg-white p-8 hs-card-shadow">
          <h1 className="font-display text-2xl font-bold text-[#0B2B33]">Accept invite</h1>
          <p className="mt-1 text-sm text-[#43535E]">Choose a password to join your workspace.</p>
          <form onSubmit={onSubmit} className="mt-6 space-y-4">
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-[#8A97A0]">Invite token</label>
              <input
                data-testid="invite-token-input"
                value={token} onChange={(e) => setToken(e.target.value)} required
                className="w-full rounded-lg border border-[#E4E9EF] px-3 py-2.5 text-sm text-[#0B2B33]"
              />
            </div>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wider text-[#8A97A0]">New password</label>
              <input
                data-testid="invite-password-input"
                type="password" value={password} onChange={(e) => setPassword(e.target.value)} required
                className="w-full rounded-lg border border-[#E4E9EF] px-3 py-2.5 text-sm text-[#0B2B33]"
              />
            </div>
            <button type="submit" disabled={busy} data-testid="invite-submit-button" className="hs-btn-primary w-full">
              {busy ? "Working…" : "Accept invite"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
